// src/components/WorkingCopyBar.js - RULING 305.10 (Record 647; ruling 305.1 item 2). The officer's private working copy
// on the claim page: what is in it, "Publish to the claim", "Discard". Shown only to an officer working a filed claim.
import React, { useEffect, useState } from 'react';
import { watchCopy, publishCopy, discardCopy } from '../data/workingCopyStore';
import { worksInPrivate, pendingLines, isEmptyCopy, PRIVATE_NOTICE } from '../data/workingCopy';

const C = { line: '#2E4A6B', dim: '#8AA4BF', accent: '#E8A020', bad: '#E06C6C', ok: '#5FB878', text: '#DCE7F2' };

export default function WorkingCopyBar({ claimId, claim, user, onPublished }) {
  const [copy, setCopy] = useState(null);
  const [busy, setBusy] = useState('');
  const [msg, setMsg] = useState('');
  const on = worksInPrivate(user, claim);
  useEffect(() => (on ? watchCopy(claimId, user, setCopy) : undefined), [claimId, on, user && user.uid]);   // eslint-disable-line react-hooks/exhaustive-deps
  if (!on) return null;
  const empty = isEmptyCopy(copy);
  const publish = async () => {
    setBusy('publish'); setMsg('');
    try {
      const r = await publishCopy(claimId, claim, user);
      if (!r.ok) { setMsg('NOT published: ' + r.errors.join(' ') + ' Your working copy is unchanged.'); return; }
      setMsg('Published to the claim.');
      if (onPublished) onPublished(r.patch || {});
    } catch (e) {
      setMsg('NOT published: ' + ((e && (e.code || e.message)) || 'the write was refused') + '. Nothing on the claim changed; your working copy is unchanged.');
    } finally { setBusy(''); }
  };
  const discard = async () => {
    setBusy('discard'); setMsg('');
    try { await discardCopy(claimId, user); setMsg('Working copy discarded. Nothing on the claim changed.'); }
    catch (e) { setMsg('Not discarded: ' + ((e && (e.code || e.message)) || 'refused') + '.'); }
    finally { setBusy(''); }
  };
  return (
    <div style={{ border: '1px solid ' + (empty ? C.line : C.accent), background: empty ? 'transparent' : '#2A1F00', borderRadius: 6, padding: '10px 14px', marginBottom: 14, fontSize: 12, color: C.dim, lineHeight: 1.5 }}>
      <div style={{ color: empty ? C.dim : C.accent, fontWeight: 700, marginBottom: 4 }}>
        {empty ? 'Your working copy is empty.' : 'Your working copy - not yet on the claim'}
      </div>
      <div>{PRIVATE_NOTICE}</div>
      {!empty ? (
        <div style={{ marginTop: 8 }}>
          {pendingLines(claim, copy).map((l, i) => <div key={i} style={{ color: C.text }}>- {l}</div>)}
          <div style={{ marginTop: 8 }}>
            <button className="btn btn-primary btn-sm" disabled={!!busy} onClick={publish} style={{ marginRight: 8 }}>{busy === 'publish' ? 'Publishing...' : 'Publish to the claim'}</button>
            <button className="btn btn-secondary btn-sm" disabled={!!busy} onClick={discard}>{busy === 'discard' ? 'Discarding...' : 'Discard'}</button>
          </div>
        </div>
      ) : null}
      {msg ? <div style={{ marginTop: 6, color: /^NOT|^Not/.test(msg) ? C.bad : C.ok }}>{msg}</div> : null}
    </div>
  );
}
